import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { DoubleLink } from './media/double-link';
import { RewardsDialogContentModel } from 'models';
import { RewardsEducationContentBody } from './rewards-education-content-body';

const LinkTracked = ClickTracker(DoubleLink);

interface RewardsEducationContentProps {
  content: RewardsDialogContentModel;
}

export const RewardsEducationContent: React.FunctionComponent<RewardsEducationContentProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <React.Fragment>
      {content.header && <h1 className="uitk-type-heading-600 uitk-type-bold all-y-margin-four">{content.header}</h1>}
      <section>{content.body && content.body.map(el => <RewardsEducationContentBody key={el.toString()} {...el} />)}</section>

      {content.button &&
        content.button.text && (
          <UitkScrim type={UitkScrimType.BUTTON}>
            <LinkTracked to={content.button.href} rfrr={content.button.rfrr} linkName="Rewards Dialog Button">
              <UitkPrimaryButton
                id="join-rewards-btn"
                text={content.button.text}
                data-stid="join-rewards-btn"
                isFullWidth={true}
                size={UitkButtonSize.LARGE}
              />
            </LinkTracked>
          </UitkScrim>
        )}
    </React.Fragment>
  );
};
